/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_high_MP = require('./Q_high_MP');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_slowed = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_high_MP(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'leg_shot')) {
    node.branches[node.NO] = new UseAbility(actor, 'leg_shot');
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function (target) {
    return (
      BattleCalc.getCondition(target, 'slowed') ||
      BattleCalc.getCondition(target, 'liberated')
    );
  };

  return node;
};
module.exports = Q_slowed;
